<template>
  <div :class="'simple-page-header' + (fixed?' fixed':'')">
    <span class="title">
      <span class="flag"></span>
      <slot name="header" v-if="$slots.header"></slot>
      <span v-else>{{ header }}</span>
    </span>
    <span class="info" v-if="!!helpText">
      <i class="el-icon-warning-outline"></i>
      <el-link type="primary" :href="helpUrl" @click="helpClick">{{ helpText }}</el-link>
    </span>
    <div class="button-bar">
      <slot/>
      <btn-back v-if="backable"></btn-back>
    </div>
  </div>
</template>

<script>
import BaseVue from "@/components/base/BaseVue";
import BtnBack from "@/components/btns/BtnBack.vue";

export default {
  name: "SimplePageHeader",
  components: {BtnBack},
  extends: BaseVue,
  props: {
    header: {
      type: String,
      required: true
    },
    helpText: {
      type: String,
      required: false
    },
    helpUrl: {
      type: String,
      required: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    backable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    helpClick() {
      console.log("1");
      this.$emit("help-click");
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/css/variables";

.fixed {
  /* 开启固定定位 */
  position: sticky;
  top: 0;
  z-index: 9;
}

.simple-page-header {
  /*距离浏览器0px的时候就不动了*/
  display: flex;
  align-items: center;
  padding: 0 10px 0 20px;
  height: 46px;
  line-height: 46px;
  background-color: #f0f2f5;

  .title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    letter-spacing: 0.96px;
    line-height: 24px;
    font-weight: 500;
    span.flag{
      display: inline-block;
      width: 5px;
      height: 16px;
      background-color: #2747ec;
      margin-right: 10px;
    }
  }

  .info {
    margin-left: 20px;
    padding-top: 2px;
    display: flex;
    align-items: center;
    color: #1890FF;
    line-height: 22px;
    font-weight: 400;
    i{
      font-size: 14px;
    }

    .el-link {
      font-size: 13px;
      margin-left: 7px;
    }
  }

  .button-bar {
    flex-grow: 1;
    text-align: right;
    padding-right: 10px;

    .el-button {
      padding: 8px 18px;
      font-size: 14px;
      letter-spacing: 0;
      font-weight: 400;

      i {
        margin-right: 4px;
      }
    }

    .ivu-btn {
      margin-left: 10px;
    }
  }
}
</style>
